<template>
  <div>
    <NavBar />
    <div class="container">
      <div class="row">
        <div class="col">
          <h1>Edit User</h1>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <h4 class="py-3">{{ subTitle }}</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-xs col-lg-3">
          <ul class="nav nav-pills flex-column">
            <li class="nav-item" v-for="link in links" :key="link.href">
              <router-link :to="link.href" v-slot="{ href, isActive, navigate }">
                <a class="nav-link" :class="isActive ? 'active' : ''" :href="href" @click="navigate">{{ link.text }}</a>
              </router-link>
            </li>
          </ul>
        </div>
        <div class="col-xs col-lg-9">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NavBar from "@/views/reports/NavBar.vue";

export default {
  components: {
    NavBar,
  },
  props: {
    organizationId: String,
    userId: String,
  },
  data() {
    return {
      emailAddress: null,
      fullName: null,
    };
  },
  created() {
    this.load();
  },
  watch: {
    organizationId() {
      this.load();
    },
    userId() {
      this.load();
    },
  },
  computed: {
    ...mapGetters("role", ["isOrganizationAdministrator"]),
    ...mapGetters("feature", ["hasReports", "hasInvestigations"]),
    links() {
      let links = [{ text: "Profile", href: `/organizations/${this.organizationId}/users/${this.userId}/profile` }];
      if (this.isOrganizationAdministrator) links.push({ text: "Roles", href: `/organizations/${this.organizationId}/users/${this.userId}/roles` });
      if (this.isOrganizationAdministrator) links.push({ text: "Regions", href: `/organizations/${this.organizationId}/users/${this.userId}/regions` });
      if (this.isOrganizationAdministrator)
        links.push({ text: "Facilities/Stores", href: `/organizations/${this.organizationId}/users/${this.userId}/facilities` });
      if (this.isOrganizationAdministrator)
        links.push({ text: "Functions/Districts", href: `/organizations/${this.organizationId}/users/${this.userId}/functions` });
      if (this.isOrganizationAdministrator)
        links.push({ text: "Companies/Divisions", href: `/organizations/${this.organizationId}/users/${this.userId}/companies` });
      if (this.isOrganizationAdministrator && this.hasInvestigations) {
        links.push({ text: "Interviews", href: `/organizations/${this.organizationId}/users/${this.userId}/interviews` });
      }
      return links;
    },
    subTitle() {
      var subTitle = null;
      if (this.fullName && this.emailAddress) {
        subTitle = `${this.fullName} - (${this.emailAddress})`;
      }
      return subTitle;
    },
  },
  methods: {
    load() {
      this.$axios
        .get(`/v1/organizations/${this.organizationId}/users/${this.userId}/profile`)
        .then(res => {
          this.emailAddress = res.data.emailAddress;
          this.fullName = res.data.fullName;
        })
        .catch(() => {});
    },
  },
};
</script>
